import moment from 'moment'
import { useIntl } from 'react-intl'
import { LuxBadgeLabel } from '@lux/wardrobe-lib'
import { statusColors } from '@/app/utils/statusColorMap'
import './VisitProjectSpecs.scss'
import { ActionUserInfo } from '@/app/models/projects-service'
import VisitProjectSpecItem from './VisitProjectSpecItem'

const VisitProjectSpecs = ({
    status,
    projectTitle,
    store,
    startDate,
    projectType,
    user,
    closeDate,
    remoteVisit,
}: {
    status: string
    projectTitle: string
    store: string
    startDate: number
    projectType: string
    user: ActionUserInfo
    closeDate: number
    remoteVisit: boolean
}) => {
    const componentClass = 'smart-modals-visit-project-specs'

    const intl = useIntl()

    return (
        <div className={componentClass}>
            <h2 className={`${componentClass}__title`}>
                {intl.formatMessage({
                    id: 'modals.news_execution.project_specs.title',
                    defaultMessage: 'Project Specs',
                })}
            </h2>
            <div className={`${componentClass}__status`}>
                {status && (
                    <LuxBadgeLabel
                        label={intl.formatMessage({
                            id: `smart.project.status.${status}`,
                            defaultMessage: status,
                        })}
                        color={statusColors[status]}
                    />
                )}
            </div>
            <h2 className={`${componentClass}__subtitle`}>{projectTitle}</h2>
            <div className={`${componentClass}__details`}>
                <VisitProjectSpecItem
                    label={intl.formatMessage({
                        id: 'modals.news_execution.project_specs.details.date',
                        defaultMessage: 'Date',
                    })}
                    value={startDate ? moment(startDate).format('L') : ''}
                />
                <VisitProjectSpecItem
                    label={intl.formatMessage({
                        id: 'modals.news_execution.project_specs.details.start.time',
                        defaultMessage: 'Start Time',
                    })}
                    value={startDate ? moment(startDate).format('LT') : ''}
                />
                {closeDate && (
                    <VisitProjectSpecItem
                        label={intl.formatMessage({
                            id: 'modals.news_execution.project_specs.details.close.date',
                            defaultMessage: 'Close Date',
                        })}
                        value={closeDate ? moment(closeDate).format('L') : ''}
                    />
                )}
                <VisitProjectSpecItem
                    label={intl.formatMessage({
                        id: 'modals.news_execution.project_specs.details.store',
                        defaultMessage: 'Store',
                    })}
                    value={store}
                />
                <VisitProjectSpecItem
                    label={intl.formatMessage({
                        id: 'modals.news_execution.project_specs.details.project.type',
                        defaultMessage: 'Project Type',
                    })}
                    value={projectType}
                />
                <VisitProjectSpecItem
                    label={intl.formatMessage({
                        id: 'modals.news_execution.project_specs.details.from',
                        defaultMessage: 'From',
                    })}
                    value={
                        user?.nickname
                            ? user?.nickname
                            : `${user?.name || ''} ${user?.lastname || ''}`
                    }
                />
                <VisitProjectSpecItem
                    label={intl.formatMessage({
                        id: 'modals.new.activity.section.scheduling.remote.visit',
                        defaultMessage: 'Remote Visit',
                    })}
                    value={intl.formatMessage({
                        id: `generic.${remoteVisit ? 'yes' : 'no'}`,
                        defaultMessage: remoteVisit ? 'Yes' : 'No',
                    })}
                />
            </div>
        </div>
    )
}

export default VisitProjectSpecs
